import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-flow",
  "use": "icon-flow-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-flow\"><path d=\"M12 2c-1.5 0-2.7 1.1-2.9 2.5H5V3H1v4h4V5.5h4.1c0 .3.1.5.2.7-1.2.5-1.4 1.6-1.7 2.6-.3 1.3-.6 2.5-2.6 2.7V10H1v4h4v-1.5c2.9-.2 3.3-2.1 3.6-3.5.2-1.1.4-1.7 1.2-1.9.6.5 1.4.9 2.2.9 1.7 0 3-1.3 3-3s-1.3-3-3-3M4 6H2V4h2zm0 7H2v-2h2zm8-6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol